import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DocumentMeta from "react-document-meta";

import * as cuesApi from "../../api/cue";
import H2RButton from "../H2RComponents/H2RButton";
import H2RHeading from "../H2RComponents/H2RHeading";

import { definitions } from "../imports";
import { CueContents, cueDesign } from "./Cue";
import CueStatus from "./CueStatus";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";

const sizes = {
	small: {
		minHeight: "10vh",
		smallTextSize: "0.75rem",
		largeTextSize: "1rem",
		grid: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6",
	},
	large: {
		minHeight: "20vh",
		smallTextSize: "1rem",
		largeTextSize: "1.5rem",
		grid: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
	},
};

export default function Buttons() {
	let { projectId } = useParams();
	const [buttonSize, setButtonSize] = useState("small");

	const selectedProject = useSelector(
		(state) => state.main.projects?.[projectId]
	);
	const meta = {
		title: `Buttons - ${selectedProject?.name}`,
	};

	if (selectedProject === undefined) {
		return null;
	} else {
		return (
			<DocumentMeta {...meta}>
				<div className="bg-gray-900 min-h-screen top-0 bottom-0">
					<section className={`px-4 py-5 flex flex-col flex-1 justify-between`}>
						<div className="flex justify-between mb-4 space-x-2">
							<H2RHeading type="h6">{selectedProject.name}</H2RHeading>
							<span className="flex-1"></span>
							<H2RButton
								title="Switch to small buttons"
								text="Small"
								colour={buttonSize === "small" ? "dark" : "light"}
								size="small"
								css="w-min"
								onClick={() => {
									return setButtonSize("small");
								}}
							/>
							<H2RButton
								title="Switch to small buttons"
								text="Large"
								colour={buttonSize === "large" ? "dark" : "light"}
								size="small"
								css="w-min"
								onClick={() => {
									return setButtonSize("large");
								}}
							/>
						</div>
						<div
							className={`pt-2 pb-4 pr-2 mb-16 grid gap-2 gap-y-4 h-100 overflow-x-hidden h-auto ${sizes[buttonSize].grid}`}
						>
							{selectedProject.cues?.map((cue, index) => {
								if (cue.type === "section") return null;
								return (
									<Cue
										key={cue.id}
										cue={cue}
										index={index}
										buttonSize={buttonSize}
									/>
								);
							})}
						</div>
					</section>
					<div className="w-screen py-2 px-2 flex justify-end fixed space-x-4 bottom-0 h-16 bg-gray-800">
						<H2RButton
							title="Hide all graphics"
							text="Hide all"
							colour="dark"
							onClick={() => {
								return cuesApi.hideAll(projectId);
							}}
						/>
						<H2RButton
							title="Show/hide cued graphics"
							icon={faChevronCircleRight}
							text="Run"
							onClick={() => {
								return cuesApi.runCues(projectId);
							}}
						/>
					</div>
				</div>
			</DocumentMeta>
		);
	}
}

const Cue = ({ cue, buttonSize = "small" }) => {
	let { projectId } = useParams();
	return (
		<div
			className="flex space-x-2"
			style={{
				minHeight: sizes[buttonSize].minHeight,
			}}
		>
			{/* <button className="w-2/12 h-full bg-red-200 rounded-md">s</button> */}
			<CueStatus cue={cue} clickable={true} />
			<button
				className={`flex flex-col justify-start items-baseline rounded-md focus:outline-none focus:ring focus:${
					cueDesign(cue.type).ringColour
				}
                            ${cueDesign(cue.type).iconColour}
            `}
				style={{
					maxWidth: "80%",
					minWidth: "80%",
				}}
				onClick={() => {
					let changeTo;

					if (cue.status === "onair" || cue.status === "cuedoff") {
						changeTo = "going";
					} else if (cue.status === "coming" || cue.status === "going") {
						changeTo = "offair";
					} else {
						changeTo = "coming";
					}

					cuesApi.updateCue(cue.id, projectId, {
						status: changeTo,
					});
				}}
			>
				<span
					style={{
						fontSize: sizes[buttonSize].smallTextSize,
					}}
					className="px-2 md:px-5 py-1 pb-2 md:py-3 text-left w-full overflow-ellipsis overflow-hidden whitespace-nowrap opacity-80 uppercase font-semibold text-gray-100"
				>
					{definitions[cue.type].name}
					{cue.onAirDuration && (
						<span className="lowercase">∙ {cue.onAirDuration}s</span>
					)}
				</span>
				<span
					className="px-2 md:px-5 py-2 md:py-4 h-full  rounded-b-md text-left w-full overflow-ellipsis overflow-hidden whitespace-nowrap max-w-full"
					style={{
						fontSize: sizes[buttonSize].largeTextSize,
						background: "rgba(0,0,0,.2)",
					}}
				>
					<CueContents cue={cue} twoLines={true} />
				</span>
			</button>
		</div>
	);
};
